import { createRouter, createWebHistory } from 'vue-router'
import { t } from '@/i18n'
import Home from '../pages/Home.vue'
import Contact from '../pages/Contact.vue'
import About from '../pages/About.vue'
import Product from '../pages/Product.vue'
import ProductDetail from '../pages/ProductDetail.vue'
import News from '../pages/News.vue'
import AdminLayout from '../layouts/AdminLayout.vue'
import AdminLogin from '../pages/admin/Login.vue'
import ProductCategories from '../pages/admin/ProductCategories.vue'
import AdminProducts from '../pages/admin/AdminProducts.vue'
import AdminNews from '../pages/admin/AdminNews.vue'
import AdminBanners from '../pages/admin/AdminBanners.vue'
import AdminInquiries from '../pages/admin/AdminInquiries.vue'
import { isAdminLoggedIn } from '@/utils/adminAuth'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { isStorefront: true, title: 'Boris Bags' }
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact,
    meta: { isStorefront: true, title: 'Contact - Boris Bags' }
  },
  {
    path: '/about',
    name: 'About',
    component: About,
    meta: { isStorefront: true, title: 'About - Boris Bags' }
  },
  {
    path: '/news',
    name: 'News',
    component: News,
    meta: { isStorefront: true, title: 'FAQ - Boris Bags' }
  },
  {
    path: '/products',
    name: 'Products',
    component: Product,
    meta: { isStorefront: true, title: 'Products - Boris Bags' }
  },
  {
    path: '/products/:id',
    name: 'ProductDetail',
    component: ProductDetail,
    meta: { isStorefront: true, title: 'Product - Boris Bags' }
  },
  {
    path: '/admin/login',
    name: 'AdminLogin',
    component: AdminLogin,
    meta: { adminGuest: true }
  },
  {
    path: '/admin',
    component: AdminLayout,
    meta: { requiresAdminAuth: true },
    children: [
      { path: '', redirect: { name: 'AdminBanners' } },
      {
        path: 'banners',
        name: 'AdminBanners',
        component: AdminBanners,
        meta: { adminTitle: '首页轮播图' }
      },
      {
        path: 'catalogue',
        name: 'AdminCatalogue',
        component: ProductCategories,
        meta: { adminTitle: '产品分类管理' }
      },
      {
        path: 'products',
        name: 'AdminProducts',
        component: AdminProducts,
        meta: { adminTitle: '商品管理' }
      },
      {
        path: 'news',
        name: 'AdminNews',
        component: AdminNews,
        meta: { adminTitle: '新闻中心' }
      },
      {
        path: 'messages',
        name: 'AdminMessages',
        component: AdminInquiries,
        meta: { adminTitle: '咨询消息' }
      }
    ]
  },
  { path: '/:pathMatch(.*)*', redirect: '/' }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

const ROUTE_TITLE_KEYS = {
  Home: 'pageTitle.home',
  Contact: 'pageTitle.contact',
  About: 'pageTitle.about',
  Products: 'pageTitle.products',
  News: 'pageTitle.news'
}

router.beforeEach((to, from, next) => {
  const titleKey = ROUTE_TITLE_KEYS[to.name]
  if (titleKey) {
    document.title = t(titleKey)
  }

  const requiresAdminAuth = to.matched.some((r) => r.meta.requiresAdminAuth)
  if (requiresAdminAuth && !isAdminLoggedIn()) {
    next({ name: 'AdminLogin', query: { redirect: to.fullPath } })
    return
  }
  if (to.meta.adminGuest && isAdminLoggedIn()) {
    next({ name: 'AdminCatalogue' })
    return
  }
  next()
})

export default router
